import { render } from "./ClassDetailsCard.vue?vue&type=template&id=64ff4362&scoped=true"
import script from "./ClassDetailsCard.vue?vue&type=script&lang=js"
export * from "./ClassDetailsCard.vue?vue&type=script&lang=js"

import "./ClassDetailsCard.vue?vue&type=style&index=0&id=64ff4362&scoped=true&lang=css"

import exportComponent from "/Users/shenshenmac/codes/fan_mei/fanmei_v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ff4362"]])

export default __exports__